import { router } from 'expo-router';
import { useEffect } from 'react';

export default function NotFoundRedirect() {
  useEffect(() => {
    router.replace('/'); // Redirect to the home page
  }, []);

  return null;
}
